import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';
import { APPLY_ONBOARDING_TEMPLATE_RESOURCE } from '../../constants';

const ApplyOnboardingTemplateService = ComposedComponent =>
  reduxFetch([
    {
      resource: APPLY_ONBOARDING_TEMPLATE_RESOURCE,
      method: 'post',
      request: (communityId, memberId, body, callback, t) => ({
        url: apiRoutes.applyOnboardingTemplate(communityId, memberId),
        body,
        meta: {
          callback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'applyOnboardingTemplateFailed'),
            onSuccessMessage: t('applyOnboardingTemplateSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default ApplyOnboardingTemplateService;
